// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */

import {jsx} from 'panel';

import {DropMenu, DropMenuEl} from 'common/components/drop-menu';
import {Visibility, VisibilityEvents} from 'common/components/base/stackable';
// eslint-disable-next-line import/no-cycle
import {ContextPanelEl} from 'common/widgets/context-panel';

import type {ContextPanelMenu} from './index';

export function template(this: ContextPanelMenu) {
  if (!this.helpers.isTooltipDataSet()) {
    return <div style={{display: `none`}} />;
  }

  return (
    <DropMenuEl
      sel='.context-panel-menu'
      attrs={{
        open: Boolean(this.params.data),
        offset: this.attr(`offset`),
        skidding: this.attr(`skidding`),
        direction: this.attr(`placement`),
        'position-strategy': this.attr(`position-strategy`),
        'show-arrow': this.attr(`show-arrow`),
        'allowed-flip-directions': this.attr(`force-placement`) && [this.attr(`placement`)],
        // when the context panel is opened, don't focus it as this will cause the associated menu's search input
        // to lose focus
        'disable-auto-focus': true,
      }}
      props={{
        positionParent: this.params.positionParent,
      }}
      on={{
        click: (ev: MouseEvent) => {
          if (!(ev.target instanceof HTMLAnchorElement)) {
            ev.stopPropagation();
            ev.preventDefault();
          }
        },
        // No need to prevent mousedown event. Previously, it was opening up a menu
        // when context menu is clicked. Also, this allows text select within context panel.
      }}
      hook={{
        destroy: (vnode) => {
          const dropEl = vnode.elm as DropMenu;
          this.dispatchEvent(
            new CustomEvent(VisibilityEvents[Visibility.Closed], {
              bubbles: true,
              composed: true,
              detail: dropEl.getStackingDetail(),
            }),
          );
        },
      }}
    >
      <ContextPanelEl
        sel='.context-panel'
        params={this.getContextPanelContentParams()}
        attrs={this.getContextPanelContentAttrs()}
        on={this.getContextPanelContentEventHandlers()}
      />
    </DropMenuEl>
  );
}
